import { render, staticRenderFns } from "./split-pane.vue?vue&type=template&id=9f197a6c&scoped=true&"
import script from "./split-pane.vue?vue&type=script&lang=js&"
export * from "./split-pane.vue?vue&type=script&lang=js&"
import style0 from "./split-pane.vue?vue&type=style&index=0&id=9f197a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f197a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/apple/Desktop/linebot-backend.hciot.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f197a6c')) {
      api.createRecord('9f197a6c', component.options)
    } else {
      api.reload('9f197a6c', component.options)
    }
    module.hot.accept("./split-pane.vue?vue&type=template&id=9f197a6c&scoped=true&", function () {
      api.rerender('9f197a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/split-pane.vue"
export default component.exports